import type { KeyedReturnTypes, ThunkDispatcher } from '@gumtree/shared/src/model/generic.model';
import commonReducers, { updateCommonData } from '@gumtree/shell/src/reducers/common';
import buyerReducers, { updateBuyerData } from '@gumtree/shell/src/reducers/buyer';
import page, { updatePage } from '@gumtree/shell/src/reducers/page';
import sellerPagination, { updateSellerPagination } from './seller-pagination';
import type { Transformed } from '../get-data/transform';

import sellerAds, { updateSellerAds } from './seller-ads';

export const showPage =
    ({
        title,
        description,
        sellerAds,
        sellerPagination,
        ...data
    }: Transformed & {
        pagePath: string;
        numberOfPages: number;
        currentPage: number;
    }) =>
    (dispatch) => {
        dispatch(updateSellerAds(sellerAds));
        dispatch(updateSellerPagination(sellerPagination));
        dispatch(updateCommonData(data));
        dispatch(updateBuyerData(data));
        dispatch(updatePage({ title, description }));
    };

const index = {
    ...commonReducers,
    ...buyerReducers,
    page,
    sellerAds,
    sellerPagination,
};

export default index;

export type SelleradsState = KeyedReturnTypes<typeof index>;
export type SellerAdsThunk<Payload, Return = any> = ThunkDispatcher<
    SelleradsState,
    Payload,
    Return
>;
